module.exports = __webpack_public_path__ + "ee6e45daf1b9101e48b4f4165f8096ff.jpg";